"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveColumnHeaders = exports.ColumnHeader = exports.QuoteSectionBodyWidget = void 0;
var react_1 = __importStar(require("react"));
var es_toolkit_1 = require("es-toolkit");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Quote/Types");
var styles = __importStar(require("./QuoteSectionBodyWidget.css"));
var columnsOrder = [
    { lineItemFieldType: "description" },
    { lineItemFieldType: "customField", fieldId: Types_1.ReservedFieldIds.Item },
    { lineItemFieldType: "customField", fieldId: Types_1.ReservedFieldIds.Quantity },
    { lineItemFieldType: "price" },
];
var QuoteSectionBodyWidget = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("div", { className: styles.quoteSectionBody }, children);
};
exports.QuoteSectionBodyWidget = QuoteSectionBodyWidget;
var ColumnHeader = function (_a) {
    var data = _a.data, ColumnHeaderMenu = _a.ColumnHeaderMenu;
    return (react_1.default.createElement("div", { contentEditable: false },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", padding: "m", justify: "spaceBetween" }, data.columns.map(function (columnData, index) {
            var text = (react_1.default.createElement(kaleidoscope_1.Text, { size: "l", strong: true }, columnData.label));
            return (react_1.default.createElement(react_1.Fragment, { key: index }, ColumnHeaderMenu ? (react_1.default.createElement(ColumnHeaderMenu, { textElement: text, columnHeaderData: data, columnData: columnData })) : (text)));
        }))));
};
exports.ColumnHeader = ColumnHeader;
function deriveColumnHeaders(elements, getLineItemData) {
    var e_1, _a;
    var columnHeaders = new Map();
    var lastSeenColumnHeader = null;
    try {
        for (var _b = __values(elements.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), index = _d[0], w = _d[1];
            var lineItemData = getLineItemData(w);
            if (!lineItemData) {
                lastSeenColumnHeader = null;
                continue;
            }
            if (shouldStartNewColumnHeader(lineItemData, lastSeenColumnHeader)) {
                var columnHeader = {
                    index: index,
                    numLineItems: 0,
                    columns: transformToColumnsData(lineItemData),
                };
                columnHeaders.set(index, columnHeader);
                lastSeenColumnHeader = columnHeader;
            }
            if (lastSeenColumnHeader) {
                ++lastSeenColumnHeader.numLineItems;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return columnHeaders;
}
exports.deriveColumnHeaders = deriveColumnHeaders;
function shouldStartNewColumnHeader(currentLineItem, lastSeenColumnHeader) {
    if (lastSeenColumnHeader === null)
        return true;
    var currentLineItemColumns = transformToColumnsData(currentLineItem);
    return !(0, es_toolkit_1.isEqual)(currentLineItemColumns, lastSeenColumnHeader.columns);
}
function transformToColumnsData(lineItemData) {
    var e_2, _a;
    var columns = [];
    try {
        for (var columnsOrder_1 = __values(columnsOrder), columnsOrder_1_1 = columnsOrder_1.next(); !columnsOrder_1_1.done; columnsOrder_1_1 = columnsOrder_1.next()) {
            var c = columnsOrder_1_1.value;
            var columnData = getColumnData(c, lineItemData);
            if (columnData && columnData.visible) {
                columns.push(columnData);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (columnsOrder_1_1 && !columnsOrder_1_1.done && (_a = columnsOrder_1.return)) _a.call(columnsOrder_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return columns;
}
function getColumnData(c, lineItemData) {
    switch (c.lineItemFieldType) {
        case "description":
            return {
                lineItemFieldType: "description",
                visible: lineItemData.description.visible,
                label: lineItemData.description.label,
            };
        case "price":
            return {
                lineItemFieldType: "price",
                visible: lineItemData.price.visible,
                label: lineItemData.price.label,
            };
        case "customField": {
            var field = lineItemData.customFields.find(function (f) { return f.id === c.fieldId; });
            if (!field)
                return null;
            return {
                lineItemFieldType: "customField",
                visible: field.visible,
                label: field.label,
                fieldId: c.fieldId,
            };
        }
    }
}
